module.exports = __webpack_public_path__ + "img/rodlog_serveret.30620943.jpg";